<template>
  <span class="oa-copy-number">
    <span class="oa-copy-number-value">{{ value || '—' }}</span>
    <button ref="copyButton" class="oa-copy-number-button" type="button" :disabled="!value" title="复制单号" aria-label="复制申请单号" @click.stop><i class="el-icon-document-copy" aria-hidden="true" /></button>
  </span>
</template>
<script>
import Clipboard from 'clipboard'
export default {
  name: 'OaCopyNumber',
  props: { value: { type: String, default: '' } },
  data() { return { clipboard: null } },
  mounted() {
    this.clipboard = new Clipboard(this.$refs.copyButton, { text: () => this.value, container: this.$el })
    this.clipboard.on('success', event => { this.$message.success('单号已复制'); event.clearSelection() })
    this.clipboard.on('error', () => this.$message.error('复制失败，请选中单号手动复制'))
  },
  beforeDestroy() { if (this.clipboard) this.clipboard.destroy() }
}
</script>
<style scoped>
.oa-copy-number { display:inline-flex; align-items:center; gap:6px; max-width:100%; vertical-align:middle; }
.oa-copy-number-value { min-width:0; overflow-wrap:anywhere; }
.oa-copy-number-button { flex:none; border:0; background:transparent; padding:0 4px; color:#8491a5; font-size:14px; line-height:20px; cursor:pointer; }
.oa-copy-number-button:hover,.oa-copy-number-button:focus { color:#4480f3; }
.oa-copy-number-button:disabled { opacity:.4; cursor:default; }
</style>
